import { Check, Clock } from 'lucide-react'

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { DataCard } from '@/routes/Public/marketing/components/DataCard'
import { StepCard } from '@/routes/Public/marketing/components/StepCard'
import { Demo, DsSection } from '../primitives'

export function CardsSection() {
  return (
    <DsSection id="cards" title="Cards" marketing>
      <Demo label="App card" className="max-w-md">
        <Card>
          <CardHeader>
            <CardTitle>Policy summary</CardTitle>
            <CardDescription>Auto liability · effective Aug 1, 2026</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-ink-500 text-sm">
              $1M combined single limit, 12 power units, 14 drivers on the roster.
            </p>
          </CardContent>
        </Card>
      </Demo>
      <Demo label="StepCard + DataCard · dark surface only" dark>
        <div className="grid gap-6 md:grid-cols-2">
          <StepCard number="01" title="Tell us about your business">
            DOT number, trucks, and drivers — most of it prefills from public records.
          </StepCard>
          <DataCard
            rows={[
              { label: 'CSA score', value: 'Good', status: 'ok', icon: <Check size={14} /> },
              { label: 'Insurance', value: 'Active', status: 'ok', icon: <Check size={14} /> },
              { label: '2290 filing', value: 'Due in 12 days', status: 'watch', icon: <Clock size={14} /> },
            ]}
          />
        </div>
      </Demo>
    </DsSection>
  )
}
